import CancerDiseaseText from './CancerDiseaseText';
import CancerButtonGroup from './CancerButtonGroup';
import SectionStructure from '../../../../../components/Section/SectionStructure';

import CancerCard from './CancerCard';


export default function SectionCancerDisease() {
    
    return (

    <SectionStructure
    
        sectiontext=    { <CancerDiseaseText /> }

        sectiondiagroup=    { <CancerButtonGroup />} 

        sectioncards=  {<>

                        <CancerCard />  
            </>}
    />
)
}